import { BaseReq, UpdaterResp } from "@/core/interface";

export class QuantityRecord extends BaseReq {
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 业务编号
  name: string = ""; // 清单名称
  feature: string = ""; // 项目特征
  unit: string = ""; // 结算单位
  count: number = 0 ; // 工程量
  price: number = 0 ; // 综合单价
  totalPrice: number = 0; // 合价
  remark: string = ""; // 备注
}

export class QuantityReq extends BaseReq {
  records: QuantityRecord[] = [];
}

class QuantityDetailRecord extends UpdaterResp {
  id: string = "";
  bizNo: string = ""; // 业务编号
  name: string = ""; // 清单名称
  feature: string = ""; // 项目特征
  unit: string = ""; // 结算单位
  count: number = 0; // 工程量
  price: number = 0; // 综合单价
  totalPrice: number = 0; // 合价
  initialCount: number = 0; // 初始合同数量
  initialPrice: number = 0; // 初始合同综合单价
  initialTotalPrice: number = 0; // 初始合同单价
  remark: string = ""; // 备注
}

export class QuantityDetailResp {
  records: QuantityDetailRecord[] = [];
}

export class QuantityImportResp {
  records: QuantityRecord[] = [];
}
